import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const {
    mlbBlack,
    mlbGrey4
} = COLORS;

export const TeamMatchupLayerWrapper = styled.div.attrs({
    'data-mlb-test': 'teamMatchupContainer'
})`
    flex: 2;
    > div:first-child {
        margin-bottom: 1px;
    }
    > div {
        height: ${({ theme }) => theme?.TeamMatchupLayerWrapper?.height};
        white-space: nowrap;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 14px;
`;

// margin top is to match the team matchup component padding
export const ScoreContainer = styled.div.attrs({
    'data-mlb-test': 'scoreContainer'
})`
    font-size: 16px;
    font-weight: bolder;
    color: ${mlbBlack};
    margin-top: 0px;
    margin-right: 12px;

`;

export const ScoreWrapper = styled.div`
    width: 20px;
    text-align: center;
`;

export const RecordWrapper = styled.div.attrs({
    'data-mlb-test': 'teamRecordContainer'
})`
    font-size: ${({ theme }) => theme?.RecordWrapper?.font?.size};
    font-weight: ${({ theme }) => theme?.RecordWrapper?.font?.weight};
    color: ${mlbGrey4};
    margin-top: ${({ theme }) => theme?.RecordWrapper?.marginTop};
    line-height: ${({ theme }) => theme?.RecordWrapper?.lineHeight};
    margin-right: 12px;

    ${({ isFullyFinal, scoreHidden }) => isFullyFinal ? `
        width: 100%;
        ${!scoreHidden ? 'margin-right: 0px;' : ''}
        text-align: right;
    ` : ''}
`;

export const SSRWrapper = styled.div`
    position: relative;
`;

export const TeamWrapper = styled.div`
    visibility: hidden;
    width: 65px;
`;

export const SkeletonWrapper = styled.div`
    position: absolute;
    left: 30px;
    width: 60px;
    top: 4px;
`;
